var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuyListLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 133",
    style: {
      enableBackground: "new 0 0 500 133"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st1{stroke:#000000;stroke-miterlimit:10;}\r\n\t.st2{display:none;}\r\n\t.st3{display:inline;fill:#E26254;}\r\n\t.st4{font-family:'FuturaBT-Book';}\r\n\t.st5{font-size:939.2746px;}\r\n\t.st6{font-size:693.3785px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.4,11.7h27.4c8.7,0,15.2,0.7,19.7,2c4.5,1.3,8.1,4.1,10.8,8.2c2.7,4.1,4.1,10.7,4.1,19.9c0,6.2-1,10.5-2.9,12.9 c-1.9,2.4-5.8,4.3-11.5,5.6c6.4,1.4,10.7,3.8,12.9,7.2c2.3,3.3,3.4,8.4,3.4,15.3v9.8c0,7.1-0.8,12.4-2.5,15.9 c-1.6,3.4-4.2,5.8-7.8,7.1c-3.6,1.3-10.9,1.9-22,1.9H3.4V11.7z M30.9,29.8v23.5c1.2,0,2.1-0.1,2.7-0.1c2.7,0,4.4-0.7,5.2-2 c0.7-1.3,1.1-5.1,1.1-11.4c0-3.3-0.3-5.6-0.9-7c-0.6-1.3-1.4-2.2-2.4-2.5C35.7,30,33.8,29.8,30.9,29.8z M30.9,69.8v29.6 c3.9-0.1,6.3-0.7,7.4-1.8c1.1-1.1,1.6-3.8,1.6-8v-9.9c0-4.5-0.5-7.3-1.4-8.2C37.6,70.4,35,69.9,30.9,69.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,30.8v86.7h-26.9l0.5-7.2c-1.8,2.9-4.1,5.1-6.8,6.6s-5.8,2.2-9.2,2.2c-4,0-7.3-0.7-9.9-2.1c-2.6-1.4-4.5-3.2-5.8-5.6 c-1.2-2.3-2-4.7-2.3-7.2c-0.3-2.5-0.5-7.5-0.5-14.9V30.8h26.4v59c0,6.8,0.2,10.8,0.6,12c0.4,1.3,1.5,1.9,3.4,1.9 c2,0,3.1-0.7,3.5-2c0.4-1.3,0.6-5.5,0.6-12.6V30.8H137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,30.8l-7.5,62.7c-1.2,9.9-2.2,16.7-3,20.3c-0.8,3.6-2.1,6.6-4,9c-1.9,2.4-4.5,4.1-7.8,5.2c-3.3,1.1-8.7,1.7-16,1.7 h-16v-13.9c4.1,0,6.7-0.2,7.9-0.6s1.8-1.3,1.8-2.8c0-0.7-0.5-3.7-1.6-9.1L141,30.8h24l8.7,58.5l4.2-58.5H201.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.7,11.7v84.6h16.7v21.2h-44.2V11.7H234.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5,11.7v13.8h-27.2V11.7H284.5z M284.5,30.8v86.7h-27.2V30.8H284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.9,58.5h-23.4v-4.7c0-4-0.2-6.5-0.7-7.6c-0.5-1.1-1.6-1.6-3.4-1.6c-1.5,0-2.6,0.5-3.3,1.5c-0.7,1-1.1,2.5-1.1,4.4 c0,2.7,0.2,4.6,0.6,5.8c0.4,1.2,1.5,2.6,3.3,4.1c1.9,1.5,5.7,3.6,11.4,6.5c7.7,3.7,12.7,7.3,15.1,10.6c2.4,3.3,3.6,8.1,3.6,14.4 c0,7.1-0.9,12.4-2.7,16c-1.8,3.6-4.9,6.4-9.2,8.3c-4.3,1.9-9.5,2.9-15.5,2.9c-6.7,0-12.4-1-17.2-3.1s-8-4.9-9.8-8.5 c-1.8-3.6-2.7-9-2.7-16.2V87h23.4v5.5c0,4.7,0.3,7.7,0.9,9.1c0.6,1.4,1.8,2.1,3.5,2.1c1.9,0,3.2-0.5,3.9-1.4 c0.7-0.9,1.1-2.9,1.1-5.9c0-4.1-0.5-6.7-1.4-7.8c-1-1-6.1-4.1-15.4-9.3c-7.8-4.4-12.5-8.3-14.2-11.9c-1.7-3.5-2.5-7.8-2.5-12.6 c0-6.9,0.9-12,2.7-15.3c1.8-3.3,4.9-5.8,9.3-7.6c4.4-1.8,9.5-2.7,15.3-2.7c5.8,0,10.6,0.7,14.7,2.2c4,1.5,7.1,3.4,9.3,5.8 c2.2,2.4,3.5,4.6,3.9,6.7c0.5,2,0.7,5.2,0.7,9.6V58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.8,19.2v13.7h7.1v13.7h-7.1V93c0,5.7,0.3,8.9,0.9,9.5s3,1,7.4,1v14h-10.7c-6,0-10.3-0.3-12.9-0.8 c-2.6-0.5-4.8-1.7-6.8-3.5s-3.2-3.9-3.7-6.2c-0.5-2.3-0.7-7.8-0.7-16.4v-44h-5.7V32.8h5.7V19.2H384.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "495,17.1 490.9,61.1 411,61.1 397.7,3.7 375.7,7.8  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 427.9,
    cy: 71.8,
    rx: 12.3,
    ry: 7.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 471.4,
    cy: 72.4,
    rx: 12.3,
    ry: 7.7
  })), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 409.6,
    y1: 53.4,
    x2: 490.6,
    y2: 53.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 408.5,
    y1: 45.7,
    x2: 491.7,
    y2: 45.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 406.3,
    y1: 39.2,
    x2: 492.8,
    y2: 39.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 404.2,
    y1: 32.6,
    x2: 493.9,
    y2: 32.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 402,
    y1: 26,
    x2: 493.9,
    y2: 26
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    className: "st2"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.3021 0 0 1 296.6475 366.5202)",
    className: "st3 st4 st5"
  }, "&gt;"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.366 0 0 1 4.9937 -60.349)",
    className: "st3 st4 st6"
  }, "_"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyListLogo);
export default __webpack_public_path__ + "static/media/BuyList Logo.a63522b9e450da3644f5a3a83a877960.svg";
export { ForwardRef as ReactComponent };